// Setup the namespace for this logic
var readOnlyAgencySearchHider = readOnlyAgencySearchHider || {};

readOnlyAgencySearchHider.initialize = function() {
	ap.consoleInfo("readOnlyAgencySearchHider initialize!");
	
	if (page.readOnly==false)
		return;
	
	// Find the existing Agency Search link/button and hide it
	var spanList = $("span#AgencySearchPicker-Link");
	if (spanList==null || spanList.length<1)
		return;
	
	var agencySearchSpan = spanList[0];
	if (agencySearchSpan==null)
		return;
	
	agencySearchSpan.style.display = "none";
};